import { render, staticRenderFns } from "./AccountOpening.vue?vue&type=template&id=2a6ccb43&scoped=true&"
import script from "./AccountOpening.vue?vue&type=script&lang=js&"
export * from "./AccountOpening.vue?vue&type=script&lang=js&"
import style0 from "./AccountOpening.vue?vue&type=style&index=0&id=2a6ccb43&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6ccb43",
  null
  
)

export default component.exports